import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { LocaleListQuery } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_LOCALE_LIST = gql`
    query localeList {
        locales {
            nodes {
                localeCode
                description
            }
        }
    }
`;

export const queryLocaleList = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<LocaleListQuery>({
        query: QUERY_LOCALE_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.locales?.nodes;
};